import { Close } from "@mui/icons-material";
import { Alert, IconButton, Snackbar } from "@mui/material";

export const ManualNotification = ({ message, type = "info", close }) => {
  return (
    <Snackbar
      open
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      autoHideDuration={null} // No auto-hide
      style={{ whiteSpace: "pre-line", zIndex: 1500 }}
    >
      <Alert
        severity={type}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => close()}
          >
            <Close fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
